export enum Err {
  // user
  NO_AUTHORITY = 'onvoldoende bevoegdheid',
  KEY_NOT_FOUND = 'sleutel niet gevonden',
  CODE_NOT_CORRECT = 'verkeerde sleutel',
  USER_ALREADY_ACTIVATED = 'gebruiker al geactiveerd',
  USERNAME_ALREADY_IN_USE = 'e-mailadres al in gebruik',
  USER_NOT_FOUND = 'gebruiker niet gevonden',
  USER_NOT_ACTIVATED = 'gebruiker is nog niet geactiveerd',
  WRONG_CREDENTIALS = 'onjuiste combinatie van wachtwoord en e-mailadres',

  // client
  CLIENT_NOT_FOUND = 'bewind niet gevonden',
  CLIENT_START_DATE_CANT_BE_CHANGED = 'dit bewind heeft al transacties. De instellingsdatum kan niet meer worden gewijzigd.',
  CATCHING_UP_NO_YEAR_PROVIDED = 'Vanaf welk jaar wilt u rekening en verantwoording afleggen?',

  // account
  ACCOUNT_NOT_FOUND = 'rekening niet gevonden',
  ACCOUNT_ALREADY_UPDATED = 'transacties zijn al gedownload.',
  ACCOUNT_ALREADY_EXISTS = 'rekening is eerder toegevoegd',
  SUBCATEGORY_WITHDRAWAL_RULE = 'de transactie is automatisch toegewezen en kan dus niet worden teruggezet.',

  // PSD2
  CONNECTION_NOT_FOUND = 'verbinding niet gevonden',
  REFRESH_TOKEN_EXPIRED = 'verbinding met de bank is verlopen',

  // transaction
  CORRUPT_DATA_INTERNAL_TRANSACTION_ACCOUNT_NOT_FOUND = 'interne overboeking niet symmetrisch',
  NOT_ALL_TRANSACTIONS_ARE_CATEGORISED = 'categoriseer eerst alle transacties',

  // shared
  FORM_INVALID = 'het formulier is niet correct ingevuld',

  // SUBCATEGORY
  IMMUTABLE_SUBCATEGORY = 'deze subcategory is onveranderlijk',
  UNCATEGORIZED_TRANSACTION = 'niet alle transacties zijn ingedeeld',

  // import
  UNSUPPORTED_BANK = 'deze bank wordt niet ondersteund',
  ILLEGAL_FILE_TYPE = 'dit bestandstype wordt niet ondersteund',
  EMPTY_FILE = 'dit bestand bevat geen transacties',
  IMPORT_ING_TRANSACTIONS_INSTEAD_OF_SALDO = 'U probeert een saldo overzicht te uploaden. Deze bestanden worden door Reveon niet herkend. Probeer het nogmaals met een transactiebestand.',
  OLD_ING_CSV = 'U heeft een "Kommagescheiden CSV" bestand proberen te uploaden. Deze bestanden worden door Reveon niet herkend. Probeer het nogmaals met een "Puntkommagescheiden CSV".',
  IMPORT_UNEXPECTED_ERROR = 'Er is iets fout gegaan met het inlezen van het bestand - wij zijn hiervan op de hoogte en berichten u zo spoedig mogelijk',

  // report
  INVALID_CLIENT_USER = 'gebruikers- en bewindgegevens incompleet',
  INVALID_CLIENT = 'bewindgegevens incompleet',
  INVALID_USER = 'gebruikergegevens incompleet',
  ACCOUNTS_WITHOUT_TRANSACTIONS  = 'er zijn rekeningen zonder transacties',
  NO_ACCOUNTS_PRESENT = 'importeer eerst transacties',
  IMPORT_RABOBANK_OFFICE_CORRUPTION = 'CSV-bestand is geopend in Excel waardoor de data corrupt is geraakt',
  RV_REPORTS_ALREADY_EXIST_IN_YEAR = 'RV zijn al aangemaakt'
}
